module.exports = __webpack_public_path__ + "static/img/aluminum_cast_bgm.a82a8306.jpg";